import Vue from 'vue';
import Antd from 'ant-design-vue';
import App from './App.vue';
import router from './router';
import store from './store';
import 'ant-design-vue/dist/antd.css';
import './assets/iconfont/iconfont.css'
import VueAwesomeSwiper from 'vue-awesome-swiper';
import 'swiper/css/swiper.css';
import VueQuillEditor from "vue-quill-editor";
import * as Quill from 'quill'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

Vue.config.productionTip = false;
Vue.use(VueQuillEditor)
Vue.use(Antd);
Vue.use(VueAwesomeSwiper, /* { default options with global component } */);

Vue.prototype.BASEURL = process.env.VUE_APP_BASEROUTE;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
